<template>
  <div class="error__container">
    <h3 class="text-h3-bold black--text">페이지를 찾을 수 없습니다.</h3>
    <div class="w-full d-flex-column justify-center">
      <p class="gray--text text--darken-3 text-body-1-regular text-center">
        전화 문의 : 1833-5396
      </p>
      <p class="gray--text text--darken-3 text-body-1-regular text-center">
        (평일 : 10:00 ~ 19:00, 주말 / 공휴일 제외)
      </p>
    </div>
    <a
      href="https://poincampus.com"
      class="blue--text text-body-1-regular hover-underline"
      >https://poincampus.com</a
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NotFound",
  methods: {
    ...mapActions({
      setShowGlobalMenu: "common/setShowGlobalMenu",
    }),
  },
  created() {
    this.setShowGlobalMenu(false);
  },
  beforeDestroy() {
    this.setShowGlobalMenu(true);
  },
};
</script>

<style scoped>
.error__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: var(--main-content-height);
  padding: 20px;
  gap: 20px;
}
</style>
